export default __webpack_public_path__ + "static/media/gog.11aca65d.png";